import { SET_VEHICLES_LIST, SET_VEHICLES_INFO } from './constant';

const DEFAULT_STATE = {
  list: null,
  info: null
};

const vehiclesReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SET_VEHICLES_LIST:
      return { ...state, list: action.payload };
    case SET_VEHICLES_INFO:
      return { ...state, info: action.payload };
    default:
      return state;
  }
};

export default vehiclesReducer;
